define('views/modules/questionnaire/modal/questionnaire-responses-download-modal',[
    // Libs
    'backbone',
    'mustache',
    'html2pdf',
    'moment',
    // services
    'services/user',
    'services/i18n',
    // views
    'views/parts/modal/modal',
    'views/modules/questionnaire/responses/response-content',
    // templates
    'text!templates/modules/questionnaire/modal/questionnaire-responses-download-modal.html',

], function(
    // Libs
    Backbone, Mustache, html2pdf, moment,
    // services
    User,
    i18n,
    // views
    VModal,
    VResponseContent,
    //templates
    TQuestionnaireResponsesDownloadModal
) {
    var VQuestionnaireResponsesDownloadModal = VModal.extend({
        template: TQuestionnaireResponsesDownloadModal,

        regions: {
            list: '.questions-list',
        },

        modal: function() {
            var buttons = {
                ok: {
                    label: " ",
                    className: 'sl-icon-cloud-download btn-print',
                    callback: this.onPrint
                },
            };

            return {
                closeButton: true,
                title: i18n.t("Print"),
                size: 'large',
                buttons: buttons
            };
        },

        initialize: function(opt) {
            this.options = _.extend({}, opt);

            this.view = {
                list: new VResponseContent({ questionnaire: opt.model.get('_questionnaire'), group: User.getMainGroup(), model: opt.model }),
            };

            opt.model.setQuestionnaire(this.model.get('_questionnaire'));
            opt.model.fetch();
        },

        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext({
                logoUrl: User.get('logoUrl'),
                title: this.model.get('_questionnaire').get('title'),
                userName: this.model.getComputedUser().get('displayName'),
                dateCompleted: moment(this.model.get('dateCompleted')).format('YYYY-MM-DD')
            }));

            this.$el.empty().append(html);

            this.generateZones();

            var el = this.view.list.render().$el.find('#results-list');

            this.zone.$list.append(el);

            this.renderModal();

            return this;
        },

        ////////////
        // events //
        ////////////
        onPrint: function() {
            maxHeight = 500;
            currentHeight = 0;

            Backbone.$('#results-list > div').each(function(index) {
                currentHeight += $(this).height();
                if (currentHeight >= maxHeight) {
                    Backbone.$('#results-list > div')[index-1].className = 'html2pdf__page-break';
                    currentHeight = 0;
                }
            });

            var filename = "TotalCoaching-Questionnaire-" + moment().unix() + ".pdf";
            html2pdf(this.$modal.find(".modal-body")[0], {
                margin: 0.25,
                filename: filename,
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { dpi: 192, letterRendering: true, foreignObjectRendering: true, useCORS: true },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait', pagesplit: true, useFor: 'page' }
            });
        },

    });

    return VQuestionnaireResponsesDownloadModal;
});

